export const enum GameRequest {
    SPIN = `SPIN`,
    FREE_SPIN = `FREE_SPIN`
}

export const enum GameEvent {
    OPEN_GAME = `OPEN_GAME`,
    INITIAL_SPIN = `INITIAL_SPIN`,
    FREE_SPIN = `FREE_SPIN`,
    SPIN_ERROR = `SPIN_ERROR`
}